import React, { memo } from 'react';
import classnames from 'classnames';

const SummaryTileComponent = ({ label, value, changePercent, direction }) => (
  <div
    className={classnames('callout w100p', {
      'callout-info': direction === 'down' || direction === 'flat',
      'callout-primary': direction === 'up',
    })}
  >
    <h5 className="font-bold text-uppercase mt0">{label}</h5>
    <h3 className="mt0 text-bold text-primary">{value}</h3>
    <h6
      className={classnames('mb0', {
        'text-success': direction === 'up',
        'text-danger': direction === 'down',
        'text-muted': direction === 'flat',
      })}
    >
      <i
        className={classnames('fa pr5', {
          'fa-chevron-up': direction === 'up',
          'fa-chevron-down': direction === 'down',
        })}
      />
      {changePercent === 0 ? '-' : null}
      {changePercent}% vs prior
    </h6>
  </div>
);

export const SummaryTile = memo(SummaryTileComponent);
